export const PROPOSALIDS = {
  proposal1:
    '0x84032f801045bd637863ff6f5acf2c6a643a4b3a4e49c3936171b922fe972b00',
};
